import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../../components/Navbar";
import FeatureHighlight from "../../components/cultivars/FeatureHighlight";
import Footer from "../../components/Footer";
import ProductShowcase from "../../components/cultivars/Donkeybutter/ProductShowcase";
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";

const Donkeybutter = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Donkey Butter Cultivar - BeyondBloom™</title>
        <meta name="description" content="Experience Donkey Butter, a premium cultivar from BeyondBloom™. Known for its rich aroma and powerful effects, it's a top-tier choice for cannabis connoisseurs." />
        <meta name="keywords" content="Donkey Butter, cannabis, premium cultivar, BeyondBloom, high-quality strains, indica, relaxation" />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta property="og:title" content="Donkey Butter Cultivar - BeyondBloom™" />
        <meta property="og:description" content="Experience Donkey Butter, a premium cultivar from BeyondBloom™. Known for its rich aroma and powerful effects, it's a top-tier choice for cannabis connoisseurs." />
        <meta property="og:image" content="/images/donkey-butter.png" />
        <meta property="og:url" content="https://yourwebsite.com/donkey-butter" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Donkey Butter Cultivar - BeyondBloom™" />
        <meta name="twitter:description" content="Experience Donkey Butter, a premium cultivar from BeyondBloom™. Known for its rich aroma and powerful effects, it's a top-tier choice for cannabis connoisseurs." />
        <meta name="twitter:image" content="/images/donkey-butter.png" />
      </Helmet>

      <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />
    </>
  );
};

export default Donkeybutter;
